import { riskGradePalette } from '@innovyze/stylovyze';
import { CheckCircle } from '@mui/icons-material';
import React from 'react';

interface ConditionCellProps {
	condition: string;
}

export const ConditionCell = ({ condition }: ConditionCellProps) => {
	if (condition === '1' || condition === 'true') {
		return (
			<CheckCircle
				style={{
					color: riskGradePalette.low.dark,
					verticalAlign: 'middle',
				}}
			/>
		);
	} else {
		return <></>;
	}
};
